import Screen from './../Shared/Helpers/Screen';

window.onload = function () {
    var element = document.getElementById('print-coupon');
    if (element) {
        element.onclick = function (e) {
            e.preventDefault();

            var isMobile = Screen.isMobile;
            if (!isMobile) {
                window.print();
            }
            else {
                window.print();
            }
        };
    }
}


// WEBPACK FOOTER //
// ./Src/Coupons/coupon-print.js